export default "__VITE_ASSET__9G9bc_kL__"